import { Stack } from "~/common/mui";
import type { PageTemplateProps } from "./pageTemplateTypes";

/**
 * Slot-driven React template for the ST4 knowledge-center ContentPage, whose
 * backend {@code metadata.templateUid} is {@code "ContentPageST4Template"}.
 *
 * Page-body slots rendered in OOTB order (from contentST4LayoutPage.jsp):
 * 1. {@code NavigationInPageSlot} — sticky in-page navigation.
 * 2. {@code ST4ContentSlot}       — main content area.
 *
 * The catch-all route passes {@code body} as null; ST4 has no React island.
 */
export function ContentST4PageTemplate({ slots, body }: PageTemplateProps) {
  return (
    <Stack spacing={{ xs: 2, tablet: 3 }}>
      {slots.renderSlot("NavigationInPageSlot")}
      {slots.renderSlot("ST4ContentSlot")}
      {body}
    </Stack>
  );
}
